import EthereumService from '@/services/ethereum'
import { SHA256 } from '@/utils/hash'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }
  async resetPassword (email, password, resetPasswordToken, recaptchaToken) {
    const hashPassword = SHA256.hex(password)
    const { data } = await this.kulapApi.updatePassword(email, hashPassword, resetPasswordToken, recaptchaToken)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/service.js